/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    jQuery: any
    _: any
    tinymce: any
  }
}

import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { rememberReturnPath } from './app/core/utils/return-path.util'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

// Before bootstrap, so it beats the APP_INITIALIZER that can redirect to Dex.
rememberReturnPath()

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))

if (window.jQuery && window.jQuery.fn && window.jQuery.prototype) {
  delete window.jQuery.fn.jquery
  delete window.jQuery.prototype.jquery
}

if (window._ && window._.VERSION) {
  delete window._.VERSION
}

// if (window.tinymce) {
//   delete window.tinymce.majorVersion
//   delete window.tinymce.minorVersion
// }
